import { render, staticRenderFns } from "./direct-withdraw-player-modal.vue?vue&type=template&id=13b3f1a7&"
import script from "./direct-withdraw-player-modal.vue?vue&type=script&lang=js&"
export * from "./direct-withdraw-player-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports